<script>
import layout from '@src/mixins/layout.vue'
import VueQr from 'vue-qr'
import createConfirmationLinksMixin from '@views/safehaven/sign-up/confirmation-links-mixin'

export default {
  components: {
    VueQr,
  },
  page: {
    title: 'Phone number Confirmation',
    meta: [
      { name: 'description', content: 'The Phone number Confirmation page.' },
    ],
  },

  mixins: [
    layout,
    createConfirmationLinksMixin('(auth)/phone-number-confirmation'),
  ],

  mounted() {
    const token = this.$route.query.token
    const uid = this.$route.query.uid

    if (!token || !uid) {
      this.$router.push({ name: 'login' })
    }
    if (this.isMobileDevice) {
      window.location.href = this.confirmLink
    }
  },
}
</script>

<template>
  <v-container fluid class="px-6">
    <v-row>
      <v-col :class="$style.title">Phone Number Confirmation</v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="text-center">
        Welcome to HealthBook+! You're just one step away from completing your
        registration.
      </v-col>
    </v-row>

    <v-row v-if="isMobileDevice">
      <v-col cols="12" class="py-2 px-2 font-weight-bold">
        We are attempting to open the HealthBook+ app for you.
      </v-col>
      <v-col cols="12" class="py-2 px-2">
        If the app does not open automatically, please use the link below to
        confirm your phone number:
      </v-col>
      <v-col cols="12" class="py-2 px-2">
        <a :href="confirmLink">Confirm phone number</a>
      </v-col>
      <v-col cols="12" class="py-2 px-2">
        This link will take you directly to the HealthBook+ app to verify your
        phone number and complete your account setup.
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" :class="$style.description">
        To confirm your phone number, simply use your mobile device's camera to
        scan the QR Code below.
      </v-col>
      <v-row justify="center">
        <VueQr :text="qrCodeLink" :size="250"></VueQr>
      </v-row>
      <v-col cols="12" class="mb-4" :class="$style.description">
        Scanning this QR code will automatically verify your phone number and
        complete your account setup.
      </v-col>
      <v-col cols="12" class="py-2 px-2">
        If you're viewing this on a mobile device, please use the link below to
        confirm your phone number:
      </v-col>
      <v-col cols="12" class="py-2 px-2 mb-4">
        <a :href="confirmLink">Confirm phone number</a>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.title {
  font-size: 1.25em;
  text-align: center;
}

.description {
  font-size: 0.9em;
}
</style>
